import { getCookie } from "$javascript/cookies.js"

function appendRef(url) {
  const ref = getCookie('ref') || new URLSearchParams(location.search).get('ref');
  if (!ref) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'ref=' + encodeURIComponent(ref);
}

function initCheckoutLinks() {
  document.querySelectorAll('[data-checkout]').forEach(function(el) {
    el.href = appendRef(el.href);
  });
}

function syncCheckoutRevenue(revenue) {
  document.querySelectorAll('[data-checkout]').forEach(function(el) {
    const url = new URL(el.href, location.href);
    url.searchParams.set('revenue', revenue);
    el.href = url.toString();
  });
}

// Tier calculator on the pricing card. Markup contract (see pricing.liquid):
// #tier-calculator carries data-tiers ([{max, price}], max null = open-ended)
// and data-locale; #tier-slider drives #tier-revenue, #tier-price,
// #tier-annual and the [data-tier-row] highlight.
function initTierCalculator() {
  const root = document.getElementById('tier-calculator');
  if (!root) return;

  const tiers = JSON.parse(root.dataset.tiers);
  const locale = root.dataset.locale || 'nl-NL';
  const slider = document.getElementById('tier-slider');
  const revenueEl = document.getElementById('tier-revenue');
  const priceEl = document.getElementById('tier-price');
  const annualEl = document.getElementById('tier-annual');
  const rows = root.querySelectorAll('[data-tier-row]');
  const annualDiscount = 0.9;

  function euro(amount) {
    const cents = amount % 1 !== 0;
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: cents ? 2 : 0,
      maximumFractionDigits: cents ? 2 : 0
    }).format(amount);
  }

  function update() {
    const revenue = Number(slider.value);
    const atMax = revenue >= Number(slider.max);
    let index = tiers.findIndex(function(t) { return t.max !== null && revenue < t.max; });
    if (index === -1) index = tiers.length - 1;

    revenueEl.textContent = euro(revenue) + (atMax ? '+' : '');
    priceEl.textContent = euro(tiers[index].price);
    annualEl.textContent = euro(tiers[index].price * annualDiscount);
    syncCheckoutRevenue(revenue);

    rows.forEach(function(row, i) {
      const active = i === index;
      row.classList.toggle('bg-green-50', active);
      row.querySelector('[data-tier-label]').classList.toggle('text-green-900', active);
      row.querySelector('[data-tier-label]').classList.toggle('text-gray-500', !active);
      row.querySelector('[data-tier-value]').classList.toggle('text-green-900', active);
      row.querySelector('[data-tier-value]').classList.toggle('text-gray-900', !active);
    });
  }

  slider.addEventListener('input', update);
  update();
}

document.addEventListener('DOMContentLoaded', function() {
  initCheckoutLinks();
  initTierCalculator();
});
